import { PureConnect, React } from '../../react';
import { INoteChat } from '../../types';
import { notechatEditor } from './resource';
import cx from './style.less';
import { Btn } from '../../react-toolbox-redesign/button';
import { notesEditor } from '../notes/resource';
import selectorsParticipantPopup from '../noteParticipantSelectPopup/selectors';
import selectorsCategoryPopup from '../categorySelectPopup/selectors';

export const NoteChatEditArea = PureConnect(`NoteChatEditArea`)(
    (state) => ({
        item: notechatEditor.selectors.item(state),
        updating: notechatEditor.selectors.updating(state),
        creatingNote: notesEditor.selectors.creating(state),
        updatingNote: notesEditor.selectors.updating(state),        
        selectNote: state.selection.creating,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        selectTextArea: state.selection.creating,
        flyoverVisible: state.flyover.visible,
    }),
    (dispatch) => ({ 
        change: (item: INoteChat) => { dispatch(notechatEditor.actions.APPLY({ item }));},
    }),
    ({ item,  change, updating, creatingNote, updatingNote, selectNote, participantPopupVisible, categoryPopupVisible, selectTextArea, flyoverVisible}) => {

        var visible = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        if (updating) item.text = !item.text ? '': item.text; 
        
        return (              
                <div aria-labelledby= "Geef notitie reactie" 
                    className={cx((!visible) ? 'wcag-invisible' : '')}
                    aria-hidden={!(visible)}>
                        <div className={cx('notechat-container', 'edit-note', flyoverVisible ? 'flyover' : 'modal')}>
                            <title>
                                <span className={cx('title-text')}>Reactie bewerken</span>
                            </title>
                            <span className={cx('sub-title-chat')}>Reactie<span className={cx('important-icon')}>*</span></span>                            
                            <div className={cx('input-text-chat')}>                                
                                <textarea 
                                    className={cx('input-text-chat-area')} 
                                    placeholder="Type hier uw reactie..." 
                                    name="q" 
                                    ref="term" 
                                    aria-multiline
                                    value={item.text}                     
                                    onChange={(x) => {
                                        item.text=x.target.value;
                                        change(item);
                                    }} />                   
                            </div>                   
                        </div>
                </div>         
        );
});

export const NoteChatSaveArea = PureConnect(`NoteChatSaveArea`)(
    (state) => ({
        creating: notechatEditor.selectors.creating(state),
        item: notechatEditor.selectors.item(state),
        updating: notechatEditor.selectors.updating(state),
        creatingNote: notesEditor.selectors.creating(state),
        updatingNote: notesEditor.selectors.updating(state),        
        selectNote: state.selection.creating,
        origin: state.notemenu.origin,
        participantPopupVisible: selectorsParticipantPopup.visible(state),
        categoryPopupVisible: selectorsCategoryPopup.visible(state),
        selectTextArea: state.selection.creating,
    }),
    (dispatch) => ({
        cancel: () => dispatch(notechatEditor.actions.RESET({})),
        cancelUpdating: () => {
            dispatch(notechatEditor.actions.UPDATE_CANCEL({}));
        },
        saveUpdating: (item: INoteChat) => {
            dispatch(notechatEditor.actions.UPDATE_CONTINUE({ item }));
        },

    }),
    ({  updating, creatingNote, updatingNote, selectNote, item, saveUpdating, cancelUpdating, participantPopupVisible, categoryPopupVisible, selectTextArea }) => {
        var visible = updating && !creatingNote && !updatingNote && !selectNote && !participantPopupVisible && !categoryPopupVisible && !selectTextArea;
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een notitie aan">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container', participantPopupVisible || categoryPopupVisible ? 'wcag-invisible' : '')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt, () => { cancelUpdating(); });
                            }}
                            onClick={() => { cancelUpdating(); }}
                        >
                            <span>Annuleren</span>
                        </Btn>

                        <Btn
                            type="button"
                            className={'btn'}
                            aria-label={'Opslaan'}
                            aria-haspopup={false}
                            tabIndex={item.text ? 0 : -1}
                            disabled={!item.text}
                            onKeyDown={(evt: any) => { handleEnters(evt, () => saveUpdating(item));
                            }}
                            onClick={() => saveUpdating(item)}
                        >
                            <span>Opslaan</span>
                        </Btn>
                    </div>

                </div>
            </div>

        );
    });

function handleEnters(evt: any, funct: () => void) {
    if (evt.key === 'Enter') { evt.preventDefault(); funct(); }
}   



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/notechat/editChatArea.tsx